module.exports = __webpack_public_path__ + "static/107.ec42b985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/107.png
// module id = 472
// module chunks = 35783957827783